<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "routesWrapper"
};
</script>

<style scoped></style>
